import { useQuery } from '@tanstack/react-query';
import { HttpNOTES } from '../api/httpNOTES';

export const useNOTESGrafico = (idOperacion: number) => {
  return useQuery({
    queryKey: ['notes-grafico', idOperacion],
    queryFn: () => HttpNOTES.getGraficoSubyacentes(idOperacion),
    enabled: !!idOperacion,
    staleTime: 1000 * 60 * 30,
  });
};